import { render, staticRenderFns } from "./c_home_bargain.vue?vue&type=template&id=acd8f674&scoped=true&"
import script from "./c_home_bargain.vue?vue&type=script&lang=js&"
export * from "./c_home_bargain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd8f674",
  null
  
)

export default component.exports